module.exports = __webpack_public_path__ + "img/logo-partner1.25ed6cd2.png";